<div class="nc-wrapper">

  <!-- Page header -->
  <div class="nc-page-header">
    <div>
      <h1 class="nc-title">Notification Center</h1>
      <p class="nc-subtitle">View and manage all your notifications in one place.</p>
    </div>
  </div>

  <!-- Main card -->
  <div class="nc-card">

    <!-- ── Toolbar: filters + bulk actions ─────────────────────────────── -->
    <div class="nc-toolbar">

      <div class="nc-filters">
        <!-- Type filter -->
        <div class="nc-filter-group">
          <label class="nc-filter-label">Type</label>
          <p-multiSelect
            [options]="typeOptions"
            [(ngModel)]="selectedTypes"
            placeholder="All Types"
            optionLabel="label"
            optionValue="value"
            (onChange)="onFilterChange()"
            styleClass="nc-type-select"
            [showHeader]="true"
            [filter]="false">
          </p-multiSelect>
        </div>

        <!-- Read status filter -->
        <div class="nc-filter-group">
          <label class="nc-filter-label">Read Status</label>
          <p-selectButton
            [options]="readStatusOptions"
            [(ngModel)]="readStatus"
            optionLabel="label"
            optionValue="value"
            (onChange)="onFilterChange()">
          </p-selectButton>
        </div>
      </div>

      <!-- Bulk actions -->
      <div class="nc-bulk-actions">
        <button
          pButton
          pRipple
          type="button"
          icon="pi pi-check-circle"
          label="Mark all as read"
          class="p-button-text nc-mark-all-btn"
          [disabled]="!hasUnread"
          (click)="onMarkAllAsRead()"
          aria-label="Mark all notifications as read">
        </button>
        <button
          pButton
          pRipple
          type="button"
          icon="pi pi-trash"
          label="Dismiss selected"
          class="p-button-text p-button-danger nc-dismiss-bulk-btn"
          [disabled]="selectedIds.length === 0"
          (click)="onDismissSelected()"
          aria-label="Dismiss selected notifications">
        </button>
        <span class="nc-selected-count">{{ selectedIds.length }} selected</span>
      </div>
    </div>

    <!-- ── Loading ──────────────────────────────────────────────────────── -->
    <div *ngIf="loading" class="nc-loading">
      <p-progressSpinner strokeWidth="3" [style]="{ width: '40px', height: '40px' }">
      </p-progressSpinner>
    </div>

    <!-- ── Notification list ────────────────────────────────────────────── -->
    <ng-container *ngIf="!loading && notifications.length > 0">

      <!-- Select-all header row -->
      <div class="nc-list-header">
        <p-checkbox
          [ngModel]="allSelected"
          [binary]="true"
          name="selectAll"
          (onChange)="toggleSelectAll($event.checked)"
          aria-label="Select all notifications">
        </p-checkbox>
        <span class="nc-list-header-label">Select all</span>
      </div>

      <!-- Rows -->
      <div class="nc-list">
        <div
          *ngFor="let n of notifications"
          class="nc-row"
          [class.nc-row--unread]="!n.isRead"
          (click)="onRowClick(n)">

          <p-checkbox
            [value]="n._id"
            [(ngModel)]="selectedIds"
            name="selectedIds"
            (click)="$event.stopPropagation()"
            [attr.aria-label]="'Select ' + n.name">
          </p-checkbox>

          <div class="nc-row-icon" [ngClass]="typeConfig(n.type).bgClass">
            <i [class]="typeConfig(n.type).icon"></i>
          </div>

          <div class="nc-row-body">
            <span class="nc-row-name">{{ n.name }}</span>
            <span class="nc-row-desc">{{ n.description }}</span>
          </div>

          <div class="nc-row-meta">
            <span
              class="nc-type-badge"
              [ngClass]="typeConfig(n.type).badgeClass">
              {{ typeConfig(n.type).label }}
            </span>
            <span class="nc-time">{{ timeAgo(n.createdAt) }}</span>
            <span
              class="nc-dot"
              [class.nc-dot--unread]="!n.isRead"
              [attr.aria-label]="n.isRead ? 'Read' : 'Unread'">
            </span>
            <button
              pButton
              pRipple
              type="button"
              icon="pi pi-trash"
              class="p-button-rounded p-button-text p-button-sm nc-dismiss-row-btn"
              [attr.aria-label]="'Dismiss notification: ' + n.name"
              (click)="onDismiss(n, $event)">
            </button>
          </div>

        </div>
      </div>
    </ng-container>

    <!-- ── Empty state ──────────────────────────────────────────────────── -->
    <div *ngIf="!loading && notifications.length === 0" class="nc-empty">
      <div class="nc-empty-icon-wrap">
        <i class="pi pi-bell nc-empty-bell"></i>
      </div>
      <p class="nc-empty-title">You're all caught up.</p>
      <p class="nc-empty-sub" *ngIf="hasFilters">
        No notifications match your current filters.
      </p>
      <p class="nc-empty-sub" *ngIf="!hasFilters">No notifications to show.</p>
      <button
        *ngIf="hasFilters"
        pButton
        pRipple
        type="button"
        label="Clear filters"
        class="p-button-outlined nc-clear-btn"
        (click)="clearFilters()">
      </button>
    </div>

    <!-- ── Footer: total + paginator ───────────────────────────────────── -->
    <div class="nc-footer" *ngIf="!loading">
      <span class="nc-total">Total {{ total | number }} notifications</span>
      <p-paginator
        [totalRecords]="total"
        [rows]="pageSize"
        [rowsPerPageOptions]="[10, 25, 50]"
        (onPageChange)="onPageChange($event)"
        styleClass="nc-paginator">
      </p-paginator>
    </div>

  </div>
</div>
